import moment from 'moment';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

import BarMetric from '../BarMetric';

export default function FeedbackStatusOverTimeMetric({
	bucketSize,
	data,
}: {
	bucketSize: graphql.AnalyticsBucketSize;
	data: graphql.AnalyticsFeedbackStatusBucket[];
}) {
	const { t } = useTranslation();
	const theme = useTheme() as any;

	let labels: string[];

	switch (bucketSize) {
		case graphql.AnalyticsBucketSize.Day:
			labels = data.map((bucket) => {
				return moment.utc(bucket.bucketStart).format('YYYY-MM-DD');
			});
			break;
		case graphql.AnalyticsBucketSize.Week:
			labels = data.map((bucket) => {
				const date = moment.utc(bucket.bucketStart);

				if (moment.utc().startOf('year').isAfter(date)) {
					return date.format("[Week] WW [']YY");
				}

				return date.format('[Week] WW');
			});
			break;
		default:
			labels = data.map((bucket) => {
				return moment.utc(bucket.bucketStart).format("MMM [']YY");
			});
	}

	const valuesMapped = data.reduce(
		(acc, curr) => {
			const { pending, completed, overdue } = curr.counts;

			acc.pending.push(pending);
			acc.completed.push(completed);
			acc.overdue.push(overdue);

			return acc;
		},
		{
			pending: [],
			completed: [],
			overdue: [],
		} as { [key: string]: number[] },
	);

	const values = [
		{
			label: t('dashboard.metrics.feedbackStatusOverTime.labels.pending'),
			color: theme.colors.employee,
			data: valuesMapped.pending,
		},
		{
			label: t('dashboard.metrics.feedbackStatusOverTime.labels.completed'),
			color: theme.colors.green,
			data: valuesMapped.completed,
		},
		{
			label: t('dashboard.metrics.feedbackStatusOverTime.labels.overdue'),
			color: theme.colors.red,
			data: valuesMapped.overdue,
		},
	];

	return <BarMetric labels={labels} values={values} />;
}
